import api from '../../api';
import { TBet, TBetsParams } from './bets.types';

const betsURL = '/bookie/regulator/bets';

// Regulator - Betting History

export const queryBets = (params: TBetsParams) =>
  api.get<TBet[]>(betsURL, { params }).then((res) => res.data);
